module.exports = __webpack_public_path__ + "static/media/Public-Safety-Patch.acfd6941.jpg";